<div class="input-grid-gaps grid-6col">
    <app-radio-input class="fr-6" [form]="form" id="type" layout="vertical"
        [staticOptions]="types" [autoSelectFirst]="true" [prefix]="typesPrefix"></app-radio-input>

    <app-date-input [form]="form" id="issueDate" [showTime]="false" [prefix]="prefix"></app-date-input>
    <app-text-input class="fr-5" [form]="form" id="reason" [prefix]="prefix"></app-text-input>

    @switch (form.value.type) {
        @case (CsszSickNoteFillingTypeEnum.ZOLUSU) {
            <app-date-input [form]="zolusuForm" id="issuedToDate" [showTime]="false" [prefix]="prefix"></app-date-input>
        }
        @case (CsszSickNoteFillingTypeEnum.ZUSPVY) {
            <app-date-input [form]="zuspvyForm" id="walkoutsFromDate" [showTime]="false"
                [prefix]="prefix"></app-date-input>
            <app-date-input [form]="zuspvyForm" id="walkoutsToDate" [showTime]="false"
                [prefix]="prefix"></app-date-input>
        }
        @case (CsszSickNoteFillingTypeEnum.ZPNPUS) {
            <app-date-input [form]="zpnpusForm" id="stayStartDate" [showTime]="false"
                [prefix]="prefix"></app-date-input>
            <app-date-input [form]="zpnpusForm" id="stayEndDate" [showTime]="false" [prefix]="prefix"></app-date-input>
            <app-address-input class="fr-6" [form]="zpnpusForm" id="address" [prefix]="prefix"></app-address-input>
        }
    }
    <div class="fr-6 flex gap align-items-center justify-content-end">
        <p-fileupload #fu mode="basic" name="myFile[]" auto="false" [customUpload]="true"
            [chooseLabel]="'sickNotes.buttons.addDocuments' | translate"
            chooseIcon="pi pi-upload" accept="application/pdf" maxFileSize="100000">
        </p-fileupload>
        @if (fu.files.length) {
            <app-button icon="pi pi-times" (clickEvent)="fu.clear()"></app-button>
        }
    </div>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="sickNotes.buttons.sendRequest"
        (primaryClickEvent)="submit()"
        (secondaryClickEvent)="dialogRef.close()">
    </app-action-buttons>
</div>
